<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-cash-register page-icon"></i>
			</div>

			<div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2" onclick="Anvil.page.searchModal()"><i class="fa fa-lg mb-2 fa-filter"></i><br />Szűrő<span id="filter-btn-badge" class="badge rounded-pill bg-danger ms-1 d-none"></span></button><br />
				<button class="btn btn-primary pl-3 pr-3 mb-2" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button><br />

				<div class="dropend">
					<button class="btn btn-dark pl-3 pr-3" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-lg mb-2 fa-binoculars"></i><br />Nézet</button>
					<ul class="dropdown-menu">
						<li>
							<a id="btn-mode-list" class="dropdown-item p-3 active" onclick="Anvil.page.setGridMode('list')">
								<strong><i class="fa fa-list me-2"></i>Lista nézet</strong><br />
								<small>Részletes lista nézet sorokkal</small>
							</a>
						</li>
						<li>
							<a id="btn-mode-map-inspections" class="dropdown-item p-3" onclick="Anvil.page.setGridMode('map-inspections')">
								<strong><i class="fa fa-map me-2"></i>Felülvizsgálatok térkép</strong><br />
								<small>Esedékes felülvizsgálatok szerinti színezés</small>
							</a>
						</li>
						<li>
							<a id="btn-mode-map-services" class="dropdown-item p-3" onclick="Anvil.page.setGridMode('map-services')">
								<strong><i class="fa fa-map me-2"></i>Karbantartó szervizek térkép</strong><br />
								<small>Hozzárendelt karbantartó szervizek szerinti színezés</small>
							</a>
						</li>
					</ul>
				</div>

				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<ol class="breadcrumb mb-2">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Pénztárgépek</li>
						</ol>

						<div class="float-end">
							<div class="row g-2">
								<div class="col-auto d-none d-lg-block" style="width:300px;">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'operator_service_id',
												title: 'Kezelő szerviz',
												params: {
													maxItems: 1,
													options: [ { id: -1, name: '[ nem hozzárendelt ]' }, ...companies.data.filter(x => x.service_partner == 1) ],
													valueField: 'id',
													labelField: 'name',
													searchField: [ 'name' ],
													render: {
														item: (item, esc) => `<div>${esc(item.name)}</div>`,
														option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
													},
													placeholder: '[ minden szerviz ]'
												},
												unset_value: null,
												prepend: '<span class="input-group-text"><i class="fa fa-headset"></i></span>',
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.operator_service_id = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-none d-lg-block" style="width:300px;">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'partner_service_id',
												title: 'Karbantartó szerviz',
												params: {
													maxItems: 1,
													options: [ { id: -1, name: '[ nem hozzárendelt ]' }, ...companies.data.filter(x => x.service_partner == 1) ],
													valueField: 'id',
													labelField: 'name',
													searchField: [ 'name' ],
													render: {
														item: (item, esc) => `<div>${esc(item.name)}</div>`,
														option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
													},
													placeholder: '[ minden szerviz ]'
												},
												unset_value: null,
												prepend: '<span class="input-group-text"><i class="fa fa-toolbox"></i></span>',
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.partner_service_id = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto" style="width:300px; max-width:50vw;">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'text',
												inline: true,
												name: 'expression',
												title: 'Szöveges keresés',
												attributes: {
													placeholder: 'Keresés...'
												},
												append: '<span class="input-group-text"><i class="fa fa-search"></i></span>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-lg-none">
									<button id="filter-btn-2" class="btn btn-dark position-relative" onclick="Anvil.page.searchModal()"><i class="fa fa-fw fa-filter"></i><span id="filter-btn-badge-2" class="badge rounded-pill bg-danger position-absolute top-0 start-100 translate-middle d-none"></span></button>
								</div>
							</div>
						</div>
						<h2 class="pt-1">Pénztárgépek</h2>
					</div>

					<%
					const get_rel = (map, offset, parent_key, child_key) => {

						const parent_val = (row) => {
							if (Array.isArray(parent_key)) {
								return parent_key.map(k => row[k]).join('_')
							} else {
								return row[parent_key]
							}
						}

						const prev_row = map[offset - 1] || false
						const row = map[offset]
						const next_row = map[offset + 1] || false

						const parent = parent_val(row)
						const self = row[child_key]

						const pd = !prev_row || (self !== prev_row[child_key]) || (parent !== parent_val(prev_row))	// previous line is different
						const nd = !next_row || (self !== next_row[child_key]) || (parent !== parent_val(next_row))	// next line is different

						var fc = true	// this is the first child
						for (let o = offset; o >= 0; o--) {
							if (parent_val(map[o]) != parent) break
							if (map[o][child_key] != self) {
								fc = false
								break
							}
						}
						var lc = true	// this is the last child
						for (let o = offset; o < map.length; o++) {
							if (parent_val(map[o]) != parent) break
							if (map[o][child_key] != self) {
								lc = false
								break
							}
						}

						if (fc && lc && pd) return { p:true, b:false, d:true }
						else if (fc && pd) return { p:true, b:true, d:true }
						else if (!pd && !lc) return { p:false, b:true, d:false }
						else if (pd && !lc) return { p:false, b:true, d:true }
						else if (pd && lc) return { p:false, b:false, d:true }
						else return { p:false, b:false, d:false }
					}
					%>

					<%- include('/ui/grid', {
						name: 'aee',
						list: aees,
						params: {
							map: {
								markers: (rows) => {
									// Assign colors for services
									const services = Anvil.page.companies.data.filter(x => x.service_partner == 1)
									const service_colors = {}
									for (let i = 0; i < services.length; i++) {
										service_colors[services[i].id] = ['blue', 'lightgreen', 'red', 'green', 'orange', 'lightred', 'darkred', 'darkpurple', 'cadetblue', 'darkgreen', 'darkblue', 'lightblue', 'purple', 'beige', 'pink'][i % 15]
									}

									// Should return an array of objects like so:
									// { geo_coords, tooltip, popup }
									const markers = []
									for (const row of rows) {
										const terminal = row.terminal_id ? Anvil.page.terminals.getByMachineId(row.terminal_id) : null
										if (terminal && terminal.site_geo_coords) {
											const geo_coords = JSON.parse(terminal.site_geo_coords)
											if (geo_coords && Array.isArray(geo_coords) && geo_coords.length == 2) {
												const due_date = Anvil.moment(row.last_inspection_d).add(1, 'year')
												const due_date_color = (!due_date.isValid() || row.ap[0] == 'Y' || row.suspended == 1) ? 'gray' :
														   			   (due_date.isBefore(Anvil.moment().add(7, 'day'))) ? 'red' :
																	   (due_date.isBefore(Anvil.moment().add(1, 'month'))) ? 'orange' :
																	   (due_date.isBefore(Anvil.moment().add(3, 'month'))) ? 'blue' : 'green'
												const service_color = row.partner_service_id ? service_colors[row.partner_service_id] || 'gray' : 'gray'
												markers.push({
													geo_coords,
													color: Anvil.page.grid_mode == 'map-inspections' ? due_date_color : service_color,
													tooltip: row.ap,
													popup: `
														<h2 style="font-weight:100;">
															<button class="btn btn-sm btn-primary" style="vertical-align:4px;" onclick="Anvil.exec('c_order/aee/modal_edit', ${row.id})"><i class="fa fa-fw fa-edit"></i></button>
															${row.ap}
														</h2>
														<p>
															${terminal.company_name}<br />
															${terminal.site_public_name || terminal.site_name}<br />
															<small class="text-dim">${terminal.site_area_code || ''} ${terminal.site_city || ''}${terminal.site_address ? ', ' + terminal.site_address : ''}</small>
														</p>
														<small>
															Következő felülvizsgálat: <strong>${due_date.isValid() ? `<strong style="color:${due_date_color};">${due_date.format('YYYY.MM.DD')}</strong> <span class="text-dim">(${due_date.fromNow()})</span>` : 'N/A'}</strong><br />
															Karbantartó szerviz: <strong>${row.partner_service_id ? (Anvil.page.companies.getById(row.partner_service_id)?.name || '[ törölt cég ]') : '[ nincs hozzárendelve ]'}</strong>
														</small><br />
													`
												})
												continue
											}
										}

										// Nem tudjuk, hogy hol van a pénztárgép
										// ...
									}
									return markers
								}
							},
							sort_order: search.sort_order,
							row_height: 48,
							row_class: (row) => {
								if (row.ap[0] == 'Y' || row.suspended == 1) return 'bg-body-secondary text-dim'
								return ''
							},
							columns: [
								{
									title: 'AP',
									field: 'ap',
									type: 'string',
									type: {
										render (value, row, options) {
											if (value) {
												return `<img src="/assets/ecr/${value.substring(0, 4)}.png" alt="" class="float-start me-2" style="height:38px;" /><span class="text-primary">${value}</span><br /><small class="text-dim">${row.type_name || '[ismeretlen]'}</small>`
											} else {
												return value
											}
										}
									},
									options: {
										class: 'text-end text-strong'
									},
									width: 160
								},
								{
									title: 'Cég',
									field: 'company_id',
									value: (v, row) => {
										const company = Anvil.page.companies.getById(v)
										if (company) {
											return `${company.name} ${company.tax_number}`
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											if (row.company_id === null) return '&nbsp;<br /><small>&nbsp;</small>'

											const company = Anvil.page.companies.getById(row.company_id)
											if (company) {
												return `${company.name}<br /><small class="text-dim">${company.tax_number}</small>`
											} else {
												return `<span class="text-warning">[ törölt cég ]</span><br /><small class="text-dim">-</small>`
											}
										}
									},
									options: {
										cutoff: 60
									},
									width: 240
								},
								/*
								{
									title: 'Csoport',
									field: 'company_id',
									value: (v, row) => {
										const company = Anvil.page.companies.getById(v)
										if (company) {
											return company.group_id
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											if (value === null) return '&nbsp;<br /><small>&nbsp;</small>'
											return `<img src="/assets/groups/${value}.png" />`
										}
									},
									options: {
										class: 'text-center'
									},
									width: 70
								},
								*/
								{
									title: 'Telephely',
									field: 'site_name',
									value: (v, row) => {
										const terminal = Anvil.page.terminals.getByMachineId(row.terminal_id)
										if (terminal && terminal.site_id) {
											return `${terminal.site_name} ${terminal.site_public_name} ${terminal.site_area_code || ''} ${terminal.site_city || ''} ${terminal.site_address || ''} ${terminal.site_location_name}`
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											const terminal = Anvil.page.terminals.getByMachineId(row.terminal_id)
											if (terminal && terminal.site_id) {
												return `
													<div class="list-db-id">
														<button class="btn btn-sm btn-dark px-2 py-0" onclick="Anvil.page.openSite('${terminal.company_db_id}', '${terminal.site_id}')"><i class="fa fa-sm fa-fw fa-${Anvil.models.c_order.Site.Types.find(t => t.value == terminal.site_type).icon}"></i></button><br />
														${terminal.site_geo_coords ? '<small class="text-dim"><i class="fa fa-map-marker-alt"></i></small>' : '<small class="text-warning"><i class="fa fa-map-marker-alt" style="transform:rotate(30deg);"></i></small>'}
													</div>
													${terminal.site_location_name ? `<span style="color:yellowgreen;">${terminal.site_location_name}</span> &bullet; ` : ''} ${terminal.site_public_name ? `<span>${terminal.site_public_name}</span>` : terminal.site_name}<br />
													<small class="text-dim">${terminal.site_city ? `<span class="text-gold">${terminal.site_city}</span>` : ''}` + (terminal.site_address ? `, ${terminal.site_address}` : '') + `</small>`
											} else {
												return '&nbsp;<br /><small>&nbsp;</small>'
											}
										}
									},
									options: {
										cutoff: 60
									},
									width: 280
								},
								{
									title: 'Info',
									field: 'state',
									type: {
										render (value, row, options) {
											if (value) {
												if (row.ap.startsWith('A282') || row.ap.startsWith('A295') || row.ap.startsWith('Y006')) {

													var lic_upload = row.licence_to_upload ? ` <i class="fa fa-upload text-primary"></i>` : ''

													var lic_html = '<span class="text-danger">Nincs licenc kód</span>'

													if (value.lic) {

														const regex = /([A|Y][0-9]{8})MolSoft([0-9]{4}\. ?[0-9]{2}\. ?[0-9]{2}\. [0-9]{1,2}\:[0-9]{2}\:[0-9]{2})Informatika/gmi
														const lic = Buffer.from(value.lic, 'base64').toString('utf8')
														const lic_data = regex.exec(lic)

														lic_html = '<span class="text-danger">Hibás licenc kód</span>'

														if (lic_data) {
															const lic_ap = lic_data[1]
															if (lic_ap != row.ap) {
																lic_html = `<span class="text-danger">Ez a kód nem ehhez az AP számhoz tartozik! (${lic_ap})</span>`
															} else {
																const lic_ends = Anvil.moment(lic_data[2])
																const stamp = `<br /><small>${lic_ends.format('YYYY.MM.DD')} <span class="text-dim">(${lic_ends.fromNow()})</span></small>`
																if (lic_ends.isBefore()) {
																	lic_html = '<span class="text-danger">Licenc lejárt</span>' + stamp
																} else if (lic_ends.isBefore(Anvil.moment().add(7, 'day'))) {
																	lic_html = '<span class="text-danger">Licenc hamarosan lejár</span>' + stamp
																} else if (lic_ends.isBefore(Anvil.moment().add(1, 'month'))) {
																	lic_html = '<span class="text-warning">Licenc hamarosan lejár</span>' + stamp
																} else if (lic_ends.isBefore(Anvil.moment().add(3, 'month'))) {
																	lic_html = '<span class="text-primary">Licenc érvényes</span>' + stamp
																} else {
																	lic_html = '<span class="text-success">Licenc érvényes</span>' + stamp
																}
															}
														}
													}

													return lic_html + lic_upload
												}

												if (row.ap.startsWith('A234') || row.ap.startsWith('Y047')) {
													return `<div class="float-end text-end">
																<small>HW: <span class="text-primary">${value.HWVersion}</span></small><br />
																<small>SW: <span class="text-primary">${value.SWVersion}</span></small>
															</div>
															Adatküldés: ${Anvil.moment(value.LastSendXmlDate).format('YYYY. MM. DD.')}<br />
															<small>Státusz: ${Anvil.moment(value.CurrentTime).format('YYYY. MM. DD.')}</small>`
												}
											}
											return ''
										}
									},
									options: {
										cutoff: 60
									},
									width: 200
								},
								{
									title: 'MSACSRV',
									field: 'terminal_id',
									value: (v, row) => {
										const terminal = Anvil.page.terminals.getByMachineId(row.terminal_id)
										if (terminal?.device_info?.msacsrv?.exe) {
											return terminal?.device_info?.msacsrv?.exe
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											const terminal = Anvil.page.terminals.getByMachineId(row.terminal_id)
											if (terminal?.device_info?.msacsrv?.exe) {
												return `<small class="text-dim">exe: <span class="${terminal?.device_info?.msacsrv?.exe == '2.2.0.0' ? 'text-success' : 'text-primary'}">${terminal?.device_info?.msacsrv?.exe || '-'}</span><br />dll: <span class="${terminal?.device_info?.msacsrv?.dll == '???' ? 'text-success' : 'text-primary'}">${terminal?.device_info?.msacsrv?.dll || '-'}</span></small>`
											} else {
												return '&nbsp;<br /><small>&nbsp;</small>'
											}
										}
									},
									options: {
										cutoff: 60
									},
									width: 95
								},
								{
									title: 'FW verzió',
									field: 'state',
									value: (v, row) => {
										if (v?.info?.AEEFWVersion) {
											return v.info.AEEFWVersion
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											if (row.ap.startsWith('A282') || row.ap.startsWith('A295') || row.ap.startsWith('A318') || row.ap.startsWith('Y006')) {
												return `<small class="text-dim">FW: <span class="${(row?.last_fw_ver && row?.state?.info?.AEEFWVersion != row?.last_fw_ver) ? 'text-warning' : 'text-light'}">${row?.state?.info?.AEEFWVersion || '-'}</span><br /><small class="text-dim">GSM: <span class="text-light">${row?.state?.info?.GSMSW || '-'}</span></small>`
											} else {
												return '&nbsp;<br /><small>&nbsp;</small>'
											}
										}
									},
									options: {
										cutoff: 60
									},
									width: 150
								},
								{
									title: 'Kommunikáció',
									field: 'state',
									value: (v, row) => {
										if (v?.info?.LastNAVSend) {
											const last_comm_m = Anvil.moment(row.state.info.LastNAVSend, 'YYYY.MM.DD. H:mm:ss')
											return last_comm_m.isValid() ? last_comm_m.format('YYYY.MM.DD. H:mm:ss') : ''
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											if (row.ap.startsWith('A282') || row.ap.startsWith('A295') || row.ap.startsWith('A318') || row.ap.startsWith('Y006')) {
												const signal = row?.state?.info?.GSMSignal
												var [ signal_strength, error_rate ] = signal ? signal.split('/') : [undefined, undefined]
												if (signal_strength !== undefined) {
													signal_strength = parseInt(signal_strength)
													error_rate = parseInt(error_rate)

													var signal_html = '<span class="material-symbols-outlined text-dim float-start me-2">signal_cellular_nodata</span>'
													if (signal_strength == 99) {
														// Nincs jel
														signal_html = `<span class="material-symbols-outlined text-danger float-start me-2">signal_cellular_nodata</span>`
													} else if (signal_strength < 10) {
														// Nagyon gyenge
														signal_html = `<span class="material-symbols-outlined text-warning float-start me-2">signal_cellular_0_bar</span>`
													} else if (signal_strength < 15) {
														// Gyenge
														signal_html = `<span class="material-symbols-outlined text-warning float-start me-2">signal_cellular_1_bar</span>`
													} else if (signal_strength < 20) {
														// Közepes
														signal_html = `<span class="material-symbols-outlined text-success float-start me-2">signal_cellular_2_bar</span>`
													} else if (signal_strength < 25) {
														// Jó
														signal_html = `<span class="material-symbols-outlined text-success float-start me-2">signal_cellular_3_bar</span>`
													} else {
														// Nagyon jó
														signal_html = `<span class="material-symbols-outlined text-success float-start me-2">signal_cellular_4_bar</span>`
													}

													var last_comm_html = ''
													if (row?.state?.info?.LastNAVSend) {
														const last_comm_m = Anvil.moment(row.state.info.LastNAVSend, 'YYYY.MM.DD. H:mm:ss')

														// Ha az utolsó kommunikáció régebben volt, mit 3 nap
														if (last_comm_m.isBefore(Anvil.moment().subtract(3, 'days'))) {
															last_comm_html = `<small class="text-danger">Uk: ${last_comm_m.fromNow()}</small>`
														} else {
															last_comm_html = `<small class="text-dim">Uk: ${last_comm_m.fromNow()}</small>`
														}

													}

													return `${signal_html}<small class="text-dim">${row?.state?.info?.GSMServiceInfo || '-'}</small><br />${last_comm_html}`

												} else {
													return '&nbsp;<br /><small>&nbsp;</small>'
												}
											} else {
												return '&nbsp;<br /><small>&nbsp;</small>'
											}
										}
									},
									options: {
										cutoff: 60
									},
									width: 130
								},
								{
									title: 'Következő felülvizsgálat',
									field: 'last_inspection_d',
									value: (v, row) => {
										return v ? Anvil.moment(v).add(1, 'year').format('YYYY.MM.DD') : ''
									},
									type: {
										render (value, row, options) {

											const inspection_btn = `<button class="btn btn-dark text-warning p-2 float-end ms-2" onclick="Anvil.exec('c_order/aee_event/modal_edit', null, '${row.id}', 'yearly_inspection')"><i class="fa fa-fw fa-calendar-check"></i> Bejegyzés</button>`
											const disabled_inspection_btn = `<button class="btn btn-dark text-dim p-2 float-end ms-2" disabled><i class="fa fa-fw fa-calendar-check"></i> Bejegyzés</button>`

											if (row.ap[0] == 'Y') {
												return `<strong class="text-dark">Teszt gép</strong>`
											} else if (row.suspended == 1) {
												return `<strong class="text-dark">Felfüggesztve</strong>`
											} else if (value) {
												const due_date = Anvil.moment(value)
												if (due_date.isBefore()) {
													// Past due
													return `${inspection_btn}<span class="text-danger"><i class="fa fa-exclamation-circle me-2"></i>${due_date.format('YYYY.MM.DD')}</span><br /><small>${due_date.fromNow()}</small>`
												}
												if (due_date.isBefore(Anvil.moment().add(7, 'day'))) {
													// Due in less than a week
													return `${inspection_btn}<span class="text-danger">${due_date.format('YYYY.MM.DD')}</span><br /><small>${due_date.fromNow()}</small>`
												}
												if (due_date.isBefore(Anvil.moment().add(1, 'month'))) {
													// Due in less than a month
													return `${inspection_btn}<span class="text-warning">${due_date.format('YYYY.MM.DD')}</span><br /><small>${due_date.fromNow()}</small>`
												}
												if (due_date.isBefore(Anvil.moment().add(3, 'month'))) {
													// Due in less than 3 months
													return `${disabled_inspection_btn}<span class="text-primary">${due_date.format('YYYY.MM.DD')}</span><br /><small>${due_date.fromNow()}</small>`
												}
												return `${disabled_inspection_btn}<span class="text-success">${due_date.format('YYYY.MM.DD')}</span><br /><small>${due_date.fromNow()}</small>`
											} else {
												return ''
											}
										}
									},
									options: {
										class: 'text-end'
									},
									width: 210
								},
								{
									title: 'Kezelő szerviz',
									field: 'operator_service_id',
									value: (v, row) => {
										const service = Anvil.page.companies.getById(v)
										if (service) {
											return `${service.name} ${service.tax_number}`
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											const service = Anvil.page.companies.getById(row.operator_service_id)
											if (service) {
												return `${service.name}`
											} else {
												return '&nbsp;<br /><small>&nbsp;</small>'
											}
										}
									},
									options: {
										cutoff: 60
									},
									width: 160
								},
								{
									title: 'Karbantartó szerviz',
									field: 'partner_service_id',
									value: (v, row) => {
										const service = Anvil.page.companies.getById(v)
										if (service) {
											return `${service.name} ${service.tax_number}`
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											const service = Anvil.page.companies.getById(row.partner_service_id)
											if (service) {
												return `${service.name}`
											} else {
												return '&nbsp;<br /><small>&nbsp;</small>'
											}
										}
									},
									options: {
										cutoff: 60
									},
									width: 160
								},
								{
									title: 'Műveletek',
									field: 'id',
									value: (v, row) => {
										if (row.company_group_name !== null) {
											return row.company_group_name
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											const notes_btn = (row.notes)
												?  `<div class="btn-group">
														<button class="btn btn-dark text-primary p-2" data-bs-toggle="dropdown"><i class="fa fa-fw fa-info-circle"></i></button>
														<div class="dropdown-menu p-2 text-muted" style="width:320px; box-shadow:0 2px 5px rgba(0, 0, 0, 0.1); white-space:normal;"><small>${row.notes.replaceAll('\n', '<br />')}</small></div>
													</div>`
												: `<button class="btn btn-dark text-dim disabled p-2"><i class="fa fa-fw fa-info-circle"></i></button>`

											const log_btn = `<a class="btn btn-dark text-info p-2" href="${Anvil.href('/c_order/aee/log', { aee_id: row.id })}"><i class="fa fa-fw fa-book me-1"></i> Napló</a>`

											return `<div class="btn-group">${notes_btn}${log_btn}</div>`
										}
									},
									options: {
										class: 'text-center pb-0 overflow-visible'
									},
									width: 120
								}
							]
						}
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-success ml-2" onclick="Anvil.page.new()"><i class="fa fa-fw fa-plus"></i><span class="d-none d-md-inline ms-2">Új pénztárgép</span></button>
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
					<button class="btn btn-danger ml-2" onclick="Anvil.page.delete()"><i class="fa fa-fw fa-trash"></i><span class="d-none d-md-inline ms-2">Törlés</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	init () {
		Anvil.page.quickSearch()
	},

	searchModal () {
		Anvil.modal('/c_order/aee/page_list_search_modal', { search: Anvil.page.search, companies: Anvil.page.companies })
	},

	quickSearch () {
		const filters = []
		const params = {
			sort_order: Anvil.page.search.sort_order
		}

		if (Anvil.page.search.operator_service_id) {
			if (Anvil.page.search.operator_service_id == -1) {
				filters.push(row => row.operator_service_id === null)
				params.operator_service_id = -1
			} else {
				filters.push(row => row.operator_service_id == Anvil.page.search.operator_service_id)
				params.operator_service_id = Anvil.page.search.operator_service_id
			}
		}

		if (Anvil.page.search.partner_service_id) {
			if (Anvil.page.search.partner_service_id == -1) {
				filters.push(row => row.partner_service_id === null)
				params.partner_service_id = -1
			} else {
				filters.push(row => row.partner_service_id == Anvil.page.search.partner_service_id)
				params.partner_service_id = Anvil.page.search.partner_service_id
			}
		}

		if (Anvil.page.search.inspection_due) {
			switch (Anvil.page.search.inspection_due) {
				case 'unknown':
					filters.push(row => !row.last_inspection_d)
					break
				case 'overdue':
					filters.push(row => {
						if (!row.last_inspection_d) return false
						const due_date = Anvil.moment(row.last_inspection_d).add(1, 'year')
						return due_date.isBefore(Anvil.moment())
					})
					break
				case '7_days':
					filters.push(row => {
						if (!row.last_inspection_d) return false
						const due_date = Anvil.moment(row.last_inspection_d).add(1, 'year')
						return due_date.isBefore(Anvil.moment().add(7, 'day'))
					})
					break
				case '1_month':
					filters.push(row => {
						if (!row.last_inspection_d) return false
						const due_date = Anvil.moment(row.last_inspection_d).add(1, 'year')
						return due_date.isBefore(Anvil.moment().add(1, 'month'))
					})
					break
				case '3_months':
					filters.push(row => {
						if (!row.last_inspection_d) return false
						const due_date = Anvil.moment(row.last_inspection_d).add(1, 'year')
						return due_date.isBefore(Anvil.moment().add(3, 'month'))
					})
					break
			}

			params.inspection_due = Anvil.page.search.inspection_due
		}

		if (Anvil.page.search.ap_list) {
			filters.push(row => Anvil.page.search.ap_list.split(/[^A-Z0-9]/).filter(Boolean).includes(row.ap))
			params.ap_list = Anvil.page.search.ap_list
		}

		const expression = Anvil.page.search.expression
		if (expression) {
			params.expression = expression
		}

		// Update filter button visuals based on filter count
		if (filters.length > 0) {
			$('#filter-btn, #filter-btn-2').removeClass('btn-dark').addClass('btn-success')
			$('#filter-btn-badge, #filter-btn-badge-2').text(filters.length).removeClass('d-none')
		} else {
			$('#filter-btn, #filter-btn-2').removeClass('btn-success').addClass('btn-dark')
			$('#filter-btn-badge, #filter-btn-badge-2').text('').addClass('d-none')
		}

		// Generate URL
		window.history.replaceState({}, '', Anvil.href('/c_order/aee/list', params))

		// Apply the filters to the grid
		Anvil.models.components.Grid.find('#aee_grid').filter(expression, filters)
	},

	async refresh () {
		await Anvil.exec('c_order/aee/action_refresh')
	},

	grid_mode: 'list',

	setGridMode (mode) {

		Anvil.page.grid_mode = mode

		switch (mode) {
			case 'list':
				Anvil.models.components.Grid.find('#aee_grid').setMode('list')
				break
			case 'map-inspections':
			case 'map-services':
				Anvil.models.components.Grid.find('#aee_grid').setMode('map')
				break
			default:
				mode = 'list'
		}

		$('#btn-mode-list').removeClass('active')
		$('#btn-mode-map-inspections').removeClass('active')
		$('#btn-mode-map-services').removeClass('active')

		$(`#btn-mode-${mode}`).addClass('active')
	},

	new () {
		Anvil.exec('c_order/aee/modal_edit')
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#aee_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/aee/modal_edit', sel[0].id)
		}
	},

	openSite (company_db_id, site_id) {
		Anvil.exec('c_order/site/modal_edit', company_db_id, site_id)
	},

	delete () {
		let sel = Anvil.models.components.Grid.find('#aee_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/aee/action_delete', sel[0].id)
		}
	}
})

$('#aee_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
